// const {document}=require( 'postcss' );

import { fetchPOST } from "../Tools";


export default class Text {
    public constructor() {
        this.init();
    }

    public init(){
        if (window.CKEDITOR === undefined) {
            window.setTimeout(this.init, 200);
            return;
        }
        // Textbausteine erstellen/Bearbeiten
        if ($('.ckedit.editmode').length > 0) {
            var editor = $('.ckedit.editmode');
            (<any>CKEDITOR.dtd.$removeEmpty['i']) = false;
            if (editor.length > 0) {
                window.CKEDITOR.disableAutoInline = true;
                for (var i = 0; i < editor.length; i++) {
                    if (!window.CKEDITOR.instances[editor[i].id]) {
                        // this.parseDynText(document.getElementById(editor[i].id));
                        window.CKEDITOR.inline(editor[i]);
                        document.dispatchEvent(new CustomEvent('ckeditor:initDone', {
                            detail: {
                                editor: window.CKEDITOR.instances[editor[i].id],
                                ckeditorId: editor[i].id
                            }
                        }));

                    }
                }
            }
        }
    }
    parseDynText(container) {
        (<NodeListOf<HTMLElement>>container.querySelectorAll('.dynText')).forEach( async (dynTexElement) => {
            var data = JSON.parse(dynTexElement.dataset.json);
            const r = await fetchPOST('/Handler/HvD/TextMarker', {
                    extra: data.extra,
                    pid: data.pid,
                    type: data.type,
                    action: 'value'
            });
            this.refreshDynText(r, dynTexElement, data.type);
        });
    }
    refreshDynText (data: IDictionary, dynTexElement: HTMLElement, type: string) {
        var dd = new Date(data.eventDate);
        dynTexElement.title = data.stationName + ' [' + data.parameterId + '] vom ' + dd.toLocaleDateString() + ' ' + dd.toLocaleTimeString();
        $(dynTexElement).html(parseFloat(data.eventValue).toFixed(2) + ' ' + data.units);
    }
}
